var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"action-group"},[_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.$refs.list.open()}}},[_vm._v(_vm._s(_vm.$t('lang.食材单位管理')))]),_c('unit-list',{ref:"list"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }